module.exports = __webpack_public_path__ + "img/nav-logo.5bfc77bf.png";